import ColumnAssociation from "csi/table/matrix/ColumnAssociation";
import declare from "dojo/_base/declare";
import Query from "csi/xml/Query";
import xml from "csi/xml";
import { pathCreate } from "csi/utility/pathUtility";
import Spec from "csi/core/Spec";

const ProductStructureBOMMatrix = declare(ColumnAssociation, {
	bAllowColumnFilter: true,
	columnAssociation: "PSPlacement",
	columnPath: pathCreate("Placements"),
	columnPathQuery: new Query().Attr("MaterialUsage", xml.OP_NOT_EQUALS, "MaterialUsage:Tool", pathCreate("MaterialType", "ProductionConfig")),

	/**
	 * @override
	 * No need to render if showing OOTB Actual attribute
	 */
	shouldRenderLoneSubheader(subSpec: Spec): boolean {
		const { ra, rc } = subSpec;
		return (ra?.attributeId !== "Actual") || (rc?.type !== "PartMaterial");
	},
});

export = ProductStructureBOMMatrix;
